import type FinancingTermsOverview from '../../../contracts/FinancingTermsOverview';
import * as types from './types';

export const fetchFinancingTermsBegin = () => ({
  type: types.FETCH_FINANCING_TERMS_BEGIN
});

export const fetchFinancingTermsSuccess = (payload: unknown) => ({
  type: types.FETCH_FINANCING_TERMS_SUCCESS,
  payload
});

export const fetchFinancingTermsFailure = (error: unknown) => ({
  type: types.FETCH_FINANCING_TERMS_FAILURE,
  payload: error
});

export const fetchTermsOverviewBegin = () => ({
  type: types.FETCH_TERMS_OVERVIEW_BEGIN
});

export const fetchTermsOverviewSuccess = (payload: FinancingTermsOverview) => ({
  type: types.FETCH_TERMS_OVERVIEW_SUCCESS,
  payload
});

export const toggleCoApplicantStatusSuccess = (payload?: boolean) => ({
  type: types.TOGGLE_COAPPLICANT_STATUS_SUCCESS,
  payload
});

export const fetchTermsOverviewFailure = (error: unknown) => ({
  type: types.FETCH_TERMS_OVERVIEW_FAILURE,
  payload: error
});
